import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendCreditCardFormLinkSms = async ({
  callerId,
  phoneNumber,
  plan,
}: {
  callerId?: string;
  phoneNumber?: string;
  plan?: string | null;
}) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      phoneNumber,
      plan,
    },
    mutation: graphql(`
      mutation SendCreditCardFormLinkSms($callerId: String, $phoneNumber: String, $plan: String) {
        sendCreditCardFormLinkSms(callerId: $callerId, phoneNumber: $phoneNumber, plan: $plan)
      }
    `),
  });

  return response.data?.sendCreditCardFormLinkSms ?? false;
};
